import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTopOnNavigate = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Auth callbacks (password recovery, magic links) put token fragments in the
    // hash, which are not valid CSS selectors - querySelector would throw and
    // crash the whole app, so guard and ignore anything that is not an anchor id.
    if (hash && /^#[A-Za-z][\w-]*$/.test(hash)) {
      let el: Element | null = null;
      try {
        el = document.querySelector(hash);
      } catch {
        el = null;
      }
      if (el) {
        setTimeout(() => el!.scrollIntoView({ behavior: "smooth" }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};
